// @ts-check
import React, { createContext } from "react"
import { Consumer as ActionsConsumer, Provider as ActionsProvider } from "./broadcast/Context"

export const blockActions = {
    Consumer: ActionsConsumer,
    Provider: ActionsProvider,
}

export const user = createContext()
export const url = createContext()
export const query = createContext()
export const deviceType = createContext()
export const propertyStore = createContext()
export const editor = createContext()
export const actions = createContext()
export const direction = createContext()
export const dragDrop = createContext()
export const block = createContext()
export const record = createContext()
export const tree = createContext()
export const input = createContext()

/**
 *
 * @param {{children: (props: BlockContext) => any}} props
 */
export function BlockContextConsumer(props) {
    return (
        <input.Consumer>
            {input => (
                <record.Consumer>
                    {record => (
                        <actions.Consumer>
                            {actions => (
                                <user.Consumer>
                                    {user => (
                                        <url.Consumer>
                                            {url => (
                                                <query.Consumer>
                                                    {query => (
                                                        <deviceType.Consumer>
                                                            {deviceType => (
                                                                <propertyStore.Consumer>
                                                                    {propertyStore => (
                                                                        <editor.Consumer>
                                                                            {editor => (
                                                                                <direction.Consumer>
                                                                                    {direction => (
                                                                                        <dragDrop.Consumer
                                                                                        >
                                                                                            {dragDrop => (
                                                                                                <block.Consumer
                                                                                                >
                                                                                                    {block => (
                                                                                                        <tree.Consumer
                                                                                                        >
                                                                                                            {tree => (
                                                                                                                <ActionsConsumer
                                                                                                                >
                                                                                                                    {broadcast =>
                                                                                                                        props.children(
                                                                                                                            {
                                                                                                                                user,
                                                                                                                                query,
                                                                                                                                url,
                                                                                                                                deviceType,
                                                                                                                                propertyStore,
                                                                                                                                editor,
                                                                                                                                actions,
                                                                                                                                direction,
                                                                                                                                dragDrop,
                                                                                                                                broadcast,
                                                                                                                                block,
                                                                                                                                record,
                                                                                                                                tree,
                                                                                                                                input,
                                                                                                                            }
                                                                                                                        )
                                                                                                                    }
                                                                                                                </ActionsConsumer>
                                                                                                            )}
                                                                                                        </tree.Consumer>
                                                                                                    )}
                                                                                                </block.Consumer>
                                                                                            )}
                                                                                        </dragDrop.Consumer>
                                                                                    )}
                                                                                </direction.Consumer>
                                                                            )}
                                                                        </editor.Consumer>
                                                                    )}
                                                                </propertyStore.Consumer>
                                                            )}
                                                        </deviceType.Consumer>
                                                    )}
                                                </query.Consumer>
                                            )}
                                        </url.Consumer>
                                    )}
                                </user.Consumer>
                            )}
                        </actions.Consumer>
                    )}
                </record.Consumer>
            )}
        </input.Consumer>
    )
}

export function BlockContextProvider({ children, data, dragDropContext, tree: treeInstance }) {
    return (
        <input.Provider value={data.input}>
            <record.Provider value={data.record}>
                <actions.Provider value={data.actions}>
                    <user.Provider value={data.user}>
                        <url.Provider value={data.url}>
                            <query.Provider value={data.query}>
                                <deviceType.Provider value={data.deviceType}>
                                    <editor.Provider value={data.editor}>
                                        <direction.Provider value={data.direction}>
                                            <dragDrop.Provider value={dragDropContext}>
                                                <tree.Provider value={treeInstance}>
                                                    <block.Provider value={data.block}>
                                                        {children}
                                                    </block.Provider>
                                                </tree.Provider>
                                            </dragDrop.Provider>
                                        </direction.Provider>
                                    </editor.Provider>
                                </deviceType.Provider>
                            </query.Provider>
                        </url.Provider>
                    </user.Provider>
                </actions.Provider>
            </record.Provider>
        </input.Provider>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/ContextProviders.js